/*------------------------------
Il prefooter può contenere
- ArchitectPush
- MediaCenter (related media)
- Where to find us
------------------------------*/

import { HTMLAttributes } from 'react'

// import FooterBanner from '@/components/base/footer-banner'
import WhereToFindUs from '@/components/base/where-to-find-us'
import Banner from '@/components/sections/banner'
import MediaCenter from '@/components/sections/media-center'
import Spacer from '@/components/sections/spacer'

import { cn } from '@/lib/utils'

export type PrefooterProps = HTMLAttributes<HTMLDivElement> & {
  dark?: boolean
  footer?: any
}

const Prefooter = ({ dark, footer }: PrefooterProps) => {
  return (
    <>
      <Spacer variant="xxl" />

      <section
        data-prefooter
        className={cn('bg-[rgba(0,0,0,.04)]', {
          'bg-[rgba(255,255,255,.04)]': dark
        })}
      >
        {footer?.banner?.visibile ? <Banner {...footer?.banner} /> : null}

        {footer?.media_center?.visible ? (
          <>
            <MediaCenter
              {...footer?.media_center}
              className={cn({
                '-mt-s-spacer-2xl md:-mt-d-spacer-2xl': footer?.banner?.visibile
              })}
            />
          </>
        ) : null}

        {footer?.where_to_find_us?.visible ? (
          <WhereToFindUs
            {...footer?.where_to_find_us}
            className={cn({
              '-mt-s-spacer-2xl md:-mt-d-spacer-2xl':
                (footer?.media_center?.visible || footer?.banner?.visibile) &&
                footer?.where_to_find_us?.type === 'small'
            })}
          />
        ) : null}
      </section>
    </>
  )
}

export default Prefooter
